module.exports = __webpack_public_path__ + "media/images/pennant-354c81b59d9192014265ff16a22c31a9.svg";